module.exports = __webpack_public_path__ + "static/media/task3Planet1.29d01a87.png";